import PouchDB from 'pouchdb';

import * as util from './apiUtils';
import * as common from './apiCommon';
import * as DocType from '../constants/constant_doc_types';

export const setupDbNames = [
  'address_type',
  'budget_type',
  'cash_rounding',
  'city',
  'classification',
  'country',
  'coupon_type',
  'credit_type',
  'csv_record',
  'csv_status',
  'currency',
  'delivery_status',
  'delivery_type',
  'device',
  'device_access_audit',
  'device_status',
  'device_type',
  'display_template',
  'entity',
  'entity_preference',
  'entity_roles',
  'entity_type',
  'exchange_rate',
  'reporting_exchange_rate',
  'reporting_period',
  'facet',
  'feature',
  'frequency',
  'hotkey_group',
  'import_type',
  'inventory_status',
  'item',
  'item_type',
  'language',
  'location',
  'location_type',
  'credit_hold_reason_code',
  'oauth2_client',
  'payment_type',
  'price_level',
  'price_book',
  'promotion_type',
  'reason_code',
  'related_entity_type',
  'report',
  'roles',
  'state',
  'subsidiary',
  'task',
  'task_type',
  'tax_code',
  'tax_group',
  'tax_type',
  'tax_schedule',
  'template_type',
  'till_movement_type',
  'transaction_category',
  'transaction_status',
  'device_status',
  'transaction_type',
  'void_audit_type',
  'zipcode'
];

export function SetupData(docType) {
  const db = new PouchDB(docType);
  return db.allDocs({ include_docs: true });
}


export function getRecordForSaveAs(app, params) {
  return common.getDoc(app, params)
    .then(result => {
      const copied = transformDocIds(result);
      return clearFieldsForSaveAs(copied);
    })
}

function transformDocIds(doc) {
  switch (doc.doc_type) {
    case DocType.PAYMENT_TYPE:
    case DocType.TASK:
      util.convertSingleDocId(doc);
    break;
    
    default:
      util.convertDocIds(doc); 
    break;
  }

  return doc;
} 

/*
  When doing a "Save As" some doc types needs specific cleanup of fields
  before showing the copied the doc to the ui. Use this for doctype-specific
  logic of clearing these fields.
 */
function clearFieldsForSaveAs(doc) {
  delete doc._id;
  delete doc.id;
  delete doc.rev;
  delete doc.system_defined;
  delete doc.created_datetime;
  delete doc.id_ext;
  delete doc.cid;
  delete doc.pid;
  delete doc.last_updated;
  delete doc.last_updated_by_id;
  delete doc.created_by_id;
  delete doc.last_updated_by;
  delete doc.created_by;
  delete doc.createdAt;
  delete doc.updatedAt;

  doc.name = `${doc.name} COPY`;

  switch (doc.doc_type) {
    case 'item': {
      delete doc.number;
      break;
    }
    case 'device': {
      delete doc.device_id;
      break;
    }
    case 'task': {
      delete doc.attachments;
      break;
    }
    default: break;
  }
  return doc;
}


export function fetchDataById(app, data) {
  const { id, docType } = data;
  return common.getDoc(app, { id, docType });
}

export function getTransactionByLocation(app, data) {
  const service = common.getAccountService(app, DocType.SALE_TRANSACTION);
  const locationId = data.id;

  const options = {
    selector: {
      doc_type: DocType.SALE_TRANSACTION,
      location: {
        _id: locationId
      }
    },
    // profile: app.get('user_info')
  };

  return service.find({ query: options })
    .then(res => {
      const hasSale = res.docs && res.docs.length > 0;
      return hasSale;
    });
}

export function deleteRecord(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: data.doc_type
  });
}


export function processCSVImport(app, action) {
  const dataImportService = common.getAccountService(app, DocType.CSV_RECORD);
  var message = action.payload.message;
  dataImportService.create(JSON.parse(message), dataImportService.user_query).then(resp => {
    console.log("response ======> ", resp);
  });
}




export function fetchSearchDropdown(app, params) {
  const { searchTerm, searchParams = {}, filter, dropdown_type, id } = params;
  const query = {
    id,
    dropdown_type,
    filter,
    searchTerm,
    searchParams
  };
  return common.getDropdownData(app, { query });
}

export function fetchLanguageDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'language/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchTransactionTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'transaction_type/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchTransactionStatusDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'transaction_status/dropdown';

  const query = {
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
    id
  };

  return common.getDropdownList(app, { query });
}

export function fetchInventoryStatusDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'inventory_status/dropdown';

  const query = {
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
    id
  };

  return common.getDropdownList(app, { query });
}

export function fetchEntityTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity_type/dropdown';

  const query = {
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
    id
  };

  return common.getDropdownList(app, { query });
}

export function fetchEntityDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'entity/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchItemAlternateNumberDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'item/alternate_number/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}


// TODO: this is a temporary workaround since these functions are being used at `sagasAdmin`
export function getCouchSetupDbURL(app, userInfo) {
  const configService = app.service('config');
  return configService.get('db_url', userInfo);
}
export function initializePouchDb() { }
export function listSetupData() { }
export function fetchListDataArrayWithId() { }


export async function searchTerm(app, q) {
  const query = { q };
  const docs = await common.queryDocs(app, 'search', query);
  return {docs};
}

export async function searchDocType(app, params) {
  const { searchTerm, searchParams, fields, id, type, dropdown_type } = params;
  return common.search(app, {
    ...searchParams,
    fields,
    id,
    q: searchTerm,
    doc_type: type || dropdown_type,
  });
}
